package features.attendance.handlers

import kotlinx.browser.window
import AppState
import features.attendance.data.AttendanceRepository

/**
 * Debug function to log all attendance data to console
 * This will NOT export to CSV, only show data in console for validation
 */
fun debugAttendanceData() {
    val team = AppState.currentTeam
    val teamId = team?.id
    
    if (team == null || teamId == null) {
        window.alert("No team selected")
        return
    }
    
    console.log("📊 Fetching attendance data for team: ${team.name}")
    
    // Fetch attendance records from Firebase
    AttendanceRepository.getAttendanceRecords(teamId)
        .then { records ->
            // Get members for name lookup
            val members = AppState.members[teamId] ?: emptyList()
            
            // ========== DEBUG: Show all fetched data ==========
            console.log("========================================")
            console.log("📊 ATTENDANCE DATA DEBUG")
            console.log("========================================")
            console.log("Team ID: $teamId")
            console.log("Team Name: ${team.name}")
            console.log("Total Records: ${records.size}")
            console.log("----------------------------------------")
            
            console.log("Total Members in AppState: ${members.size}")
            members.forEach { member ->
                console.log("  - Member: ${member.name} (ID: ${member.id})")
            }
            console.log("----------------------------------------")
            
            // Log each record in detail
            records.forEachIndexed { index, record ->
                val member = members.find { it.id == record.userId }
                val memberName = member?.name ?: "Unknown (ID: ${record.userId})"
                
                console.log("Record #${index + 1}:")
                console.log("  Member: $memberName")
                console.log("  Date: ${record.date}")
                console.log("  Check In: ${record.checkIn}")
                console.log("  Check Out: ${record.checkOut}")
                console.log("  Status: ${record.status}")
                console.log("  Location: ${record.location}")
                console.log("  Check In Photo: ${if (record.checkInPhoto != null) "Available" else "None"}")
                console.log("  Check Out Photo: ${if (record.checkOutPhoto != null) "Available" else "None"}")
                console.log("  ---")
            }
            console.log("========================================")
            // ========== END DEBUG ==========
            
            window.alert("✅ Attendance data logged to console! Check browser console (F12) for details.\nTotal records: ${records.size}")
        }
        .catch { error ->
            console.error("❌ Failed to fetch attendance data:", error)
            window.alert("Failed to fetch attendance data. Please try again.")
        }
}
